'use client'

import { PropsWithChildren, useEffect } from 'react'

import { cache } from '../../utils/cache'
import { CacheContext } from './CacheContext'

type Props = PropsWithChildren & { isLoggedIn: boolean }

const CacheProvider = ({ children, isLoggedIn }: Props) => {
  // If no user is logged in, clear the cache
  useEffect(() => {
    if (!isLoggedIn) {
      cache.clear()
    }
  }, [isLoggedIn])

  useEffect(() => {
    cache.deleteOutdated()
  }, [])

  return <CacheContext.Provider value={cache}>{children}</CacheContext.Provider>
}

export default CacheProvider
